<div class="market-history">

  <ul class="nav nav-pills" role="tablist">
    <i class="ion-md-link text-muted mx-2 align-self-center" *ngIf="isLinked" style="font-size: 20px; vertical-align: middle;"></i>

    <h2 class="heading"> {{"recent-trades" | translate}}
    </h2>
    <!-- <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;"
      *ngIf="!reuters"></i> -->
    <li class="nav-item">
      <a class="nav-link active" data-toggle="pill" (click)="toggleView(true)" role="tab" aria-selected="true">
        <h6>{{"time"|translate}}</h6>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link " data-toggle="pill" (click)="toggleView(false)" role="tab" aria-selected="false">
        <h6>{{"price"|translate}}</h6>
      </a>
    </li>

    <span class="widget-reuters" container="body" matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip" *ngIf="reuters != null">
      {{reuters}}
    </span>
    <!-- <span class="heading align-items-center" *ngIf="reuters == null" style="background:#2d3034;padding: 5px; border-radius: 5px;">
        <mat-icon>link</mat-icon>
      </span> -->
        <button matTooltipPosition="left" class="p-0 m-0" matTooltip="{{ 'export-excel' | translate }}"
        (click)="exportRecentTrades()" mat-icon-button color="primary">
        <mat-icon>save_alt</mat-icon>
        </button>
  </ul>

  <div id="recent-trades">
    <table class="table" *ngIf="isTime">
      <thead *ngIf="timeTrades">
        <tr style="padding-inline-end: 10px;">
          <th style="min-width: 85px; max-width: 85px;">{{"time"|translate}}</th>
          <th style="min-width: 85px; max-width: 85px;">{{"price"|translate}}</th>
          <th style="min-width: 85px; max-width: 85px;">{{"qty"|translate}}</th>
          <th style="min-width: 85px; max-width: 85px;">{{"change"|translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="!timeTrades  && !isTradesLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody *ngIf="timeTrades!=null && timeTrades.length == 0 && !isTradesLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{'no-trades'|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isTradesLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="timeTrades != null && timeTrades?.length > 0" style="width: 100%;">
        <tr *ngFor="let item of timeTrades" style="width: 100%;">
          <td style="min-width: 85px; max-width: 85px;">{{item.EXEC_TIME | date:'h:mm:ss'}}</td>
          <td style="min-width: 85px; max-width: 85px;" [ngClass]="item.CHANGE_PRC>0? 'green' : (item.CHANGE_PRC < 0)? 'red':''">
            {{item.TRADE_PRICE}}</td>
          <td style="min-width: 85px; max-width: 85px;">{{item.TRADE_VOLUME | number: "1.0":"en-US"}}</td>
          <td style="min-width: 85px; max-width: 85px;" [ngClass]="item.CHANGE_PRC>0? 'green' : (item.CHANGE_PRC < 0)? 'red':''">
            {{item.CHANGE_PRC}} <span>%</span></td>
        </tr>
      </tbody>
    </table>

    <table class="table" *ngIf="!isTime">
      <thead>
        <tr style="padding-inline-end: 10px;">
          <th>#</th>
          <th style="min-width: 85px; max-width: 85px;">{{"price"|translate}}</th>
          <th style="min-width: 85px; max-width: 85px;">{{"qty"|translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="!priceTrades  && !isTradesLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody *ngIf="priceTrades!=null && priceTrades.TradesPerPrice == null && !isTradesLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6 class="nodata-msg"> {{'no-trades'|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isTradesLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="priceTrades != null && priceTrades?.TradesPerPrice?.length > 0" style="width: 100%;">
        <tr *ngFor="let item of priceTrades.TradesPerPrice" style="width: 100%;">
          <td>{{item.Split}}</td>
          <td style="min-width: 85px; max-width: 85px;">{{item.Price}}</td>
          <td style="min-width: 85px; max-width: 85px;">{{item.Qty | number: "1.0":"en-US"}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ngx-loading
  [show]="isRequestLoading"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>
